import React from "react";
import { Dropdown } from "react-bootstrap";
import { DateRangePicker } from "react-date-range";
import styles from "../../../popleads/assets/css/design_3.0/CustomDatePicker.module.scss";
import { customDateRanges, getDateObject } from "app/popleads/app/functions/util";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import { CustomToggleIcon } from "app/popleads/modules/activities/utils";
import moment from "moment";

const PartnerDateDropdown = ({ selectedDate, setSelectedDate }) => {
    return (
        <Dropdown id="datePickerDropdown" className="d-none d-xxl-block" align="end">
            <Dropdown.Toggle id="kt_filter_toggle" as={CustomToggleIcon}>
                <ButtonWithText buttonStyle="selectedOption" variant="primary" leftIcon="check">
                    {selectedDate?.dateString}
                </ButtonWithText>
            </Dropdown.Toggle>
            <Dropdown.Menu
                className="dropdown-menu dropdown-menu-xl px-4 py-6 dropdown-menu-anim-up"
                style={{ width: "max-content" }}
            >
                <DateRangePicker
                    className={styles.rdrDateRangePickerWrapper}
                    ranges={[selectedDate]}
                    staticRanges={customDateRanges(new Date(null), new Date())}
                    onChange={(item) => {
                        const date = getDateObject(item.selection);
                        const newDate = {
                            ...date,
                            endDate: moment(date.endDate)
                                .endOf("day")
                                .toDate(),
                        };
                        setSelectedDate(newDate);
                        const range = document.querySelector(".rdrStaticRanges")?.firstElementChild;
                        if (range && !item.selection.startDate) {
                            range.classList.add("rdrStaticRangeSelected");
                        } else {
                            range.classList.remove("rdrStaticRangeSelected");
                        }
                    }}
                    inputRanges={[]}
                    direction="vertical"
                />
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default PartnerDateDropdown;
